import { render, staticRenderFns } from "./lbSecondary.vue?vue&type=template&id=19a1892e&scoped=true&"
import script from "./lbSecondary.vue?vue&type=script&lang=js&"
export * from "./lbSecondary.vue?vue&type=script&lang=js&"
import style0 from "./lbSecondary.vue?vue&type=style&index=0&id=19a1892e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a1892e",
  null
  
)

export default component.exports